'use strict';

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  // Don't track while developing.
  if (process.env.NODE_ENV === 'production' && typeof fbq === 'function') {
    fbq('track', 'ViewContent');
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-facebook-pixel/gatsby-browser.js
// module id = 344
// module chunks = 231608221292675